import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const FEATURE_DATA = [
  {
    id: 'Multi-Lingual Intake',
    title: 'Clients can select from 104 different languages.',
  },
  {
    id: 'Program Eligibility',
    title: 'Clients can see all programs they may be eligible for.',
  },
  {
    id: 'Document Upload',
    title:
      'Clients can see a list of all the required documents for their selected programs and will be able to electronically upload them to their application.',
  },
  {
    id: 'Review Application Status',
    title: 'Clients can see the status of their applications.',
  },
  {
    id: 'Service History',
    title: 'Clients can view a history of the services they have received.',
  },
  {
    id: 'Secure Custom Survey',
    title: 'Clients can be prompted to take surveys through the kiosk.',
  },
  {
    id: 'Web-Based Access',
    title: 'Clients can access the kiosk from any internet connection.',
  },
  {
    id: 'Syncs to Database',
    title: 'Client applications sync to your CAP60 database.',
  },
];
function AddOns() {
  return (
    <div>
      <Helmet>
        <title>Client Kiosk - CAP60</title>
        <meta
          name="description"
          content="The CAP60 client kiosk shows all of the programme eligibility and documentation requirements, all in one place."
        />
        <meta name="keyword" content="client kiosk" />
      </Helmet>
      <PageBanner
        title="Cap60’s Client Kiosk"
        subtitle="Let your Clients enter their information and apply for
        programs and services"
        // description="Saves time and money!"
      />
      <ClienDesk />
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>Saves time and money!</h2>
            </div>
            <p>
              Clients can access and enter their own information in your lobby
              or with a computer from anywhere. They can log in, edit their
              information, and check eligibility without the need for a Case
              Worker.
              <br />
              Based on the information they provide, CAP60’s Client Kiosk
              automatically lists all the programs they are eligible for, as
              well as the documents they would need to submit in order to enroll
              in the programs. Clients can even upload the required documents
              through the kiosk. All information entered into the Client Kiosk
              is automatically available for review in your CAP60 database.
            </p>
            <p>
              Currently CAP60 agencies using the Client Kiosk see significant
              time savings when making the switch from manual intake to the
              kiosk. This gives your intake staff more time to interact with
              clients, finish paperwork, or provide other services around the
              agency. As technology continues to advance and become more
              accessible to all, we anticipate the client’s use of the Client
              Kiosk to increase year to year.
            </p>
            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image src={'/images/kiosk.png'} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AddOns;
